import { render } from "./SignatoryModal.vue?vue&type=template&id=c6b77e2a&scoped=true"
import script from "./SignatoryModal.vue?vue&type=script&lang=js"
export * from "./SignatoryModal.vue?vue&type=script&lang=js"

import "./SignatoryModal.vue?vue&type=style&index=0&id=c6b77e2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b77e2a"]])

export default __exports__